import { TableData, QueryTableData } from "./types";

/**
 * Strips HTML content from a string using DOM manipulation
 * @param title - The string that may contain HTML
 * @returns The text content without HTML tags
 */
function stripHtml(title: string): string {
  if (typeof document === "undefined") {
    // For server-side or test environments, use a more comprehensive fallback
    // Repeatedly remove HTML tags until none remain
    let previousValue: string;
    let currentValue: string = title;
    do {
      previousValue = currentValue;
      currentValue = currentValue.replace(/<[^>]*>/g, "");
    } while (currentValue !== previousValue);
    return currentValue
      .replace(/&nbsp;/g, " ") // Convert non-breaking spaces
      .replace(/&lt;/g, "<") // Convert less than
      .replace(/&gt;/g, ">") // Convert greater than
      .replace(/&quot;/g, '"') // Convert quotes
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec)) // Convert numeric entities
      .replace(/&#x([0-9a-fA-F]+);/g, (match, hex) => String.fromCharCode(parseInt(hex, 16))) // Convert hex entities
      .replace(/&amp;/g, "&") // Convert ampersands (decode ampersand LAST!)
      .replace(/\u00A0/g, " "); // Convert Unicode non-breaking spaces (160) to regular spaces (32)
  }

  const div = document.createElement("div");
  div.innerHTML = title;
  const result = div.textContent || div.innerText || "";
  // Convert Unicode non-breaking spaces to regular spaces for consistency
  return result.replace(/\u00A0/g, " ");
}

/**
 * Strips HTML from field column titles in table data
 * Mutates the original data object
 * @param data - Table data object containing fields array
 */
export function stripData(data: TableData): void {
  if (data.fields && data.fields.length > 0) {
    data.fields.forEach(field => {
      field.columnTitle = stripHtml(field.columnTitle);
    });
  }
}

/**
 * Strips HTML from field display names in query service table data
 * Mutates the original data object
 * @param data - Query table data object containing table.fieldDefs array
 */
export function stripDataForQuery(data: QueryTableData): void {
  if (data.table && data.table.fieldDefs && data.table.fieldDefs.length > 0) {
    data.table.fieldDefs.forEach(column => {
      column.displayName = stripHtml(column.displayName);
    });
  }
}
